module.exports = __webpack_public_path__ + "static/media/login.44c38a51.png";